import Vue from 'vue'
import VueTheMask from 'vue-the-mask'

export function initDirectives() {
    Vue.use(VueTheMask)
}
